export enum GridSelectionModes {
  None,
  Single,
  MultipleAllSelected,
  MultipleAllUnselected,
}
